import { combineReducers } from 'redux';

import usage from './usage';

export default combineReducers({
  usage,
});
